module.exports = __webpack_public_path__ + "img/img_Colleges12.b9b31f53.png";